import React from "react";
import { Link } from "react-router-dom";

import { FaFacebookF, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer
      className="
        bg-gray-900
        text-white
        mt-6
        sm:mt-8
      "
    >
      {/* MAIN FOOTER */}
      <div
        className="
          max-w-screen-2xl
          mx-auto
          px-4
          sm:px-6
          lg:px-10
          py-8
          sm:py-10
        "
      >
        {/* GRID */}
        <div
          className="
            grid
            grid-cols-1
            sm:grid-cols-2
            lg:grid-cols-3
            gap-8
            lg:gap-12
          "
        >
          {/* ABOUT */}
          <div>
            <h3
              className="
                text-lg
                sm:text-xl
                font-semibold
                mb-3
                text-gray-200
              "
            >
              About Us
            </h3>

            <p
              className="
                text-xs
                sm:text-sm
                text-gray-400
                leading-6
              "
            >
              MrHealth is a digital healthcare platform connecting patients,
              healthcare providers, and wellness services in one ecosystem. It
              is developed and operated by Sira Technologies, a registered MSME
              in India.
            </p>
          </div>

          {/* QUICK LINKS */}
          <div>
            <h3
              className="
                text-lg
                sm:text-xl
                font-semibold
                mb-3
                text-gray-200
              "
            >
              Quick Links
            </h3>

            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="
                    text-sm
                    text-gray-400
                    hover:text-blue-400
                    transition
                  "
                >
                  Home
                </Link>
              </li>

              <li>
                <Link
                  to="/about"
                  className="
                    text-sm
                    text-gray-400
                    hover:text-blue-400
                    transition
                  "
                >
                  About Us
                </Link>
              </li>

              <li>
                <Link
                  to="/legal-policies"
                  className="
                    text-sm
                    text-gray-400
                    hover:text-blue-400
                    transition
                  "
                >
                  Legal & Policies
                </Link>
              </li>
            </ul>
          </div>

          {/* CONTACT */}
          <div>
            <h3
              className="
                text-lg
                sm:text-xl
                font-semibold
                mb-3
                text-gray-200
              "
            >
              Contact Us
            </h3>

            {/* EMAIL */}
            <p
              className="
                text-xs
                sm:text-sm
                text-gray-400
                break-all
                leading-6
              "
            >
              Email:{" "}
              <a
                href="mailto:httpsmrhealth.co.in@gmail.com"
                className="
                  text-blue-400
                  hover:text-blue-300
                  hover:underline
                "
              >
                httpsmrhealth.co.in@gmail.com
              </a>
            </p>

            {/* COMPANY */}
            <div className="mt-3">
              <p
                className="
                  text-sm
                  sm:text-base
                  font-semibold
                  bg-gradient-to-r
                  from-red-500
                  via-yellow-400
                  to-yellow-500
                  bg-clip-text
                  text-transparent
                "
              >
                Sira Technologies
              </p>
            </div>

            {/* SOCIAL */}
            <div
              className="
                flex
                items-center
                gap-4
                mt-5
              "
            >
              {/* FACEBOOK */}
              <a
                href="https://www.facebook.com/profile.php?id=61578428435747"
                target="_blank"
                rel="noopener noreferrer"
                className="
                  bg-blue-600
                  hover:bg-blue-700
                  p-2.5
                  rounded-full
                  transition
                  shadow-md
                "
              >
                <FaFacebookF className="w-4 h-4 text-white" />
              </a>

              {/* INSTAGRAM */}
              <a
                href="https://www.instagram.com/mrhealthcoin/"
                target="_blank"
                rel="noopener noreferrer"
                className="
                  bg-pink-600
                  hover:bg-pink-700
                  p-2.5
                  rounded-full
                  transition
                  shadow-md
                "
              >
                <FaInstagram className="w-4 h-4 text-white" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* BOTTOM */}
      <div
        className="
          border-t
          border-gray-800
          bg-gray-950
          py-4
          px-3
        "
      >
        <p
          className="
            text-center
            text-[11px]
            sm:text-sm
            text-gray-500
          "
        >
          © 2025 MrHealth. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
